var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Criar"},on:{"click":_vm.adicionarEstilo}})])}
var staticRenderFns = []

export { render, staticRenderFns }